import "./sidebar.css";
import Logo1 from "../../assets/icons/logo1";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoMdLogOut } from "react-icons/io";
import Button from "antd/lib/button";
import NotificationIcon from "../../assets/icons/notificationIcon";
import { useDispatch, useSelector } from "react-redux";
import showFile from "../../helpers/show_file";
import { setLogoutModal } from "../../features/app/app_slice";
import Skeleton from "../../components/skeleton/index";
import { Fragment } from "react";
import version from "../../constant/version.json";
import Env from "../../constant/env.json";

const Sidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const userProfile = useSelector((state) => state.app.userProfile);
  const userProfileLoading = useSelector(
    (state) => state.app.userProfileLoading,
  );

  return (
    <div className="sidebar">
      <Link to={"/dashboard"}>
        <Logo1 />
      </Link>
      <div
        onClick={() => {
          navigate("/setting");
        }}
        className="user_information"
      >
        <div>
          {userProfileLoading ? (
            <Skeleton style={{ width: 40, height: 40, borderRadius: "50%" }} />
          ) : userProfile?.avatar ? (
            <img src={showFile(userProfile?.avatar)} alt="avatar" />
          ) : (
            <div>{userProfile?.fullname?.slice(0, 1)?.toUpperCase()}</div>
          )}
        </div>
        <div>
          {userProfileLoading ? (
            <Fragment>
              <Skeleton
                style={{
                  width: "65%",
                  height: 14,
                  marginBottom: 6,
                  borderRadius: 5,
                }}
              />
              <Skeleton
                style={{ width: "100%", height: 14, borderRadius: 5 }}
              />
            </Fragment>
          ) : (
            <Fragment>
              <h4>{userProfile?.fullname}</h4>
              <p>{userProfile?.email}</p>
            </Fragment>
          )}
        </div>
      </div>
      <div className="navbar">
        <Link
          className={
            location.pathname == "/dashboard" ||
            location.pathname == "/dashboard/members"
              ? "active_menu"
              : null
          }
          to={"/dashboard"}
        >
          Dashboard
        </Link>
        <Link
          className={
            location.pathname == "/courses" ||
            location.pathname == "/courses/new" ||
            location.pathname.includes("/courses/edit") ||
            location.pathname.includes("/courses/view")
              ? "active_menu"
              : null
          }
          to={"/courses"}
        >
          My courses
        </Link>
        <Link
          className={location.pathname == "/coupons" ? "active_menu" : null}
          to={"/coupons"}
        >
          Coupons
        </Link>
        <Link
          className={
            location.pathname == "/transactions" ? "active_menu" : null
          }
          to={"/transactions"}
        >
          Transactions
        </Link>
        {/* <Link
          className={location.pathname == "/statistics" ? "active_menu" : null}
          to={"/statistics"}
        >
          Statistics
        </Link> */}
        <Link
          className={location.pathname == "/community" ? "active_menu" : null}
          to={"/community"}
        >
          Community
        </Link>
        <Link
          className={location.pathname == "/setting" ? "active_menu" : null}
          to={"/setting"}
        >
          Setting
        </Link>
        <Link
          className={location.pathname == "/faqs" ? "active_menu" : null}
          to={"/faqs"}
        >
          FAQs
        </Link>
      </div>
      <div className="notif_logout_btn">
        {/* <div className="notif_btn">
          <Button>
            <NotificationIcon />
            <span>Notifications</span>
          </Button>
          <div>2</div>
        </div> */}

        <Button
          onClick={() => {
            dispatch(setLogoutModal(true));
          }}
          className="logout_btn"
        >
          <IoMdLogOut />
          <span>Logout</span>
        </Button>
      </div>
      <span>
        version {version.version}
        {Env.base_url == "https://devapi.naranel.com/api/" ? (
          <span
            className="font-medium"
            style={{ fontStyle: "italic", marginLeft: 8 }}
          >
            (development)
          </span>
        ) : null}
      </span>
    </div>
  );
};

export default Sidebar;
